import React from 'react';

import { Box, ButtonGroup } from '@mui/material';

import { FORM_FIELD_TYPES, FormField } from '../../../components/form/form-field';
import SaveButton from '../../../components/form/save-button';
import SchemaEditor from '../../../components/form/schema-editor';
import { useNodeContext } from '../../../context/node-context';

const EthosV2AsyncReaderForm = ({ form, onSubmit, onChange }) => {
  const { errors } = form.formState;
  const formControl = form.control;
  const { node } = useNodeContext();
  const { id } = node;
  return (
    <Box
      component="form"
      onSubmit={form.handleSubmit(onSubmit)}
      onReset={form.reset}
      onChange={onChange}
    >
      <FormField
        controlId="ethosV2AsyncReaderFormName"
        label="name"
        name="name"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter name"
        required
        error={form.formState.errors.name?.message}
      />
      <FormField
        controlId="ethosV2AsyncReaderFormType"
        label="type"
        name="type"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        disabled
        error={form.formState.errors.type?.message}
      />
      <FormField
        controlId="ethosV2AsyncReaderFormDelayedRead"
        label="delayedRead"
        name="delayedRead"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.CHECKBOX}
      />
      <FormField
        controlId="ethosV2AsyncReaderFormConnectionKey"
        label="connectionKey"
        name="connectionKey"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors?.connectionKey?.message}
      />
      <FormField
        controlId="ethosV2AsyncReaderFormParameterizedBy"
        label="parameterizedBy"
        name="parameterizedBy"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors?.parameterizedBy?.message}
      />
      <FormField
        controlId="ethosV2AsyncReaderFormFormat"
        label="format"
        name="format"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors?.format?.message}
      />
      <FormField
        controlId="ethosV2AsyncReaderFormApiKey"
        label="apiKey"
        name="properties.apiKey"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        type="password"
        placeholder="Enter API Key"
        error={errors?.properties?.apiKey?.message}
      />
      <FormField
        controlId="ethosV2AsyncReaderFormRootUrl"
        label="rootUrl"
        name="properties.rootUrl"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter Root URL"
        error={errors?.properties?.rootUrl?.message}
      />
      <FormField
        controlId="ethosV2AsyncReaderFormMaxApiRequestRetries"
        label="maxApiRequestRetries"
        name="properties.maxApiRequestRetries"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        type="number"
        placeholder="Enter Max API Request Retries"
        error={errors?.properties?.maxApiRequestRetries?.message}
      />
      <FormField
        controlId="ethosV2AsyncReaderFormPath"
        label="path"
        name="properties.path"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter Path"
        required
        error={errors?.properties?.path?.message}
      />
      <FormField
        controlId="ethosV2AsyncReaderFormHttpMethod"
        label="httpMethod"
        name="properties.httpMethod"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.SELECT}
        placeholder="Select HTTP method"
        required
        error={errors?.properties?.httpMethod?.message}
      >
        <option value="">Select HTTP Method</option>
        <option value="GET">GET</option>
        <option value="POST">POST</option>
        <option value="PUT">PUT</option>
        <option value="DELETE">DELETE</option>
      </FormField>
      <FormField
        controlId="ethosV2AsyncReaderFormHeaders"
        label="headers"
        name="properties.headers"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXTAREA}
        placeholder="Enter Headers"
        required
        error={errors?.properties?.headers?.message}
      />
      <FormField
        controlId="ethosV2AsyncReaderFormQuery"
        label="query"
        name="properties.query"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.SPARKQL}
        placeholder="Enter Query"
        error={errors?.properties?.query?.message}
      />
      <FormField
        controlId="ethosV2AsyncReaderFormRequestIntervalMilliseconds"
        label="requestIntervalMilliseconds"
        name="properties.requestIntervalMilliseconds"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        type="number"
        placeholder="Enter Request Interval Milliseconds"
        error={errors?.properties?.requestIntervalMilliseconds?.message}
      />
      <FormField
        controlId="ethosV2AsyncReaderFormAccessTokenRefreshIntervalMinutes"
        label="accessTokenRefreshIntervalMinutes"
        name="properties.accessTokenRefreshIntervalMinutes"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter Access Token Refresh Interval Minutes"
        error={errors?.properties?.accessTokenRefreshIntervalMinutes?.message}
      />
      <FormField
        controlId="ethosV2AsyncReaderFormAccessTokenExpirationMinutes"
        label="accessTokenExpirationMinutes"
        name="properties.accessTokenExpirationMinutes"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter Access Token Expiration Minutes"
        error={errors?.properties?.accessTokenExpirationMinutes?.message}
      />
      <SchemaEditor form={form} id={id} />
      <ButtonGroup>
        <SaveButton />
      </ButtonGroup>
    </Box>
  );
};

export default EthosV2AsyncReaderForm;
